import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import { meses } from "../../variables/constants";

const Information = (props) => {
  const [information, setInformation] = useState(false);
  const [title, setTitle] = useState("Periodo");

  useEffect(() => {
    setInformation(props.data);
    let curTitle = 'Periodo ';
    if (props.data && props.data.year && props.data.month) {
      curTitle += meses[props.data.month];
    } else if (props.data && props.data.year && props.data.week) {
      curTitle += `${moment(props.data.monday).format('DD/MM/YYYY')} - ${moment(props.data.monday).add(6, 'd').format('DD/MM/YYYY')}`;
    } else if (props.data && props.data.year) {
      curTitle += 'Anual';
    }
    setTitle(curTitle);
  }, [props.data]);

  return (
    <div className="information">
      <Card
        ctTableFullWidth
        ctTableResponsive
        title={title}
        legend={<strong>Tomas Totales: {information ? information.closed + information.open + information.others : '-'}</strong>}
        content={
          (props.loading)
            ? 'Loading...'
            : <Table striped hover>
              <tbody>
                <tr style={{ backgroundColor: '#87CB16' }}>
                  <td><strong>Cerradas</strong></td>
                  <td>
                    {information ? information.closed : '-'}
                  </td>
                  <td>
                    {(information)
                      ? `(${((information.closed / (information.closed + information.open)) * 100).toFixed(2)}%)`
                      : ''}
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#FB404B' }}>
                  <td><strong>Abiertas</strong></td>
                  <td>
                    {information ? information.open : '-'}
                  </td>
                  <td>
                    {(information)
                      ? `(${((information.open / (information.closed + information.open)) * 100).toFixed(2)}%)`
                      : ''}
                  </td>
                </tr>
                <tr>
                  <td><strong>Total (parcial)</strong></td>
                  <td colSpan="2">
                    {information ? information.closed + information.open : '-'}
                  </td>
                </tr>
                <tr>
                  <td><strong>No pasa a Kavak</strong></td>
                  <td colSpan="2">
                    {information ? information.others : '-'}
                  </td>
                </tr>
              </tbody>
            </Table>
        }
      />
    </div>
  );
};

export default Information;
